import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import OrderDone from "@/pages/OrderDone";
import AuthPage from "@/pages/AuthPage";
import Account from "@/pages/Account";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSettings from "@/pages/admin/AdminSettings";

function AdminGuard({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-center text-slate-500">Yükleniyor...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/giris?next=/yonetim" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/sepet" element={<Checkout />} />
              <Route path="/siparis/:no" element={<OrderDone />} />
              <Route path="/giris" element={<AuthPage />} />
              <Route path="/hesabim" element={<Account />} />
            </Route>
            <Route path="/yonetim" element={<AdminGuard><AdminLayout /></AdminGuard>}>
              <Route index element={<AdminDashboard />} />
              <Route path="urunler" element={<AdminProducts />} />
              <Route path="siparisler" element={<AdminOrders />} />
              <Route path="odemeler" element={<AdminPayments />} />
              <Route path="musteriler" element={<AdminCustomers />} />
              <Route path="ayarlar" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
